import naja from "naja";
import InputsValidator from "../inputsValidator";


let $activeInput = null;
let cursorPosition = null;

document.addEventListener('DOMContentLoaded', () => {
    initStoreDevice();
    initCatalog();
    initDocuments();
    initItems();
});

// Zapamatování si aktivního inputu před odesláním AJAXu
naja.addEventListener('before', () => {
    const isCatalogGrid = $('#snippet-tabs-tabContent-katalog-tabControl-grid-grid');
    if (!isCatalogGrid.length) {
        return;
    }
    const $focused = $('input:focus');
    if ($focused.length && $focused.is('input[type="text"]')) {
        $activeInput = $focused;
        cursorPosition = $focused[0].selectionStart;
    }
});

// Obnovení focusu na input po dokončení AJAXu
// + stávající initItems
naja.addEventListener('complete', () => {
    const isCatalogGrid = $('#snippet-tabs-tabContent-katalog-tabControl-grid-grid');
    if (isCatalogGrid.length) {
        if ($activeInput && $activeInput.length) {
            const inputName = $activeInput.attr('name');
            const $newInput = $('input[name="' + inputName + '"]');
            if ($newInput.length) {
                $newInput.focus();
                $newInput[0].setSelectionRange(cursorPosition, cursorPosition);
            }
        }
        $activeInput = null;
        cursorPosition = null;
    }

    initItems();
    initCatalog();
});

function initStoreDevice() {
    const isStoreDevice = $('#frm-deviceTabs-tabContent-zakladniinformace-tabControl-editForm');
    if (!isStoreDevice.length) {
        return;
    }

    const storeDevice = new StoreDevice();
    storeDevice.init();

    naja.addEventListener('complete', () => {
        storeDevice.init();
    });
}

function initCatalog() {
    const isCatalog = $('#frm-catalogEditTabs-tabContent-zakladniinformace-tabControl-infoForm');
    const isCatalog2 = $('input[name="generatedEan"]');
    if (!isCatalog.length && !isCatalog2.length) {
        return;
    }

    let formEl = isCatalog.length ? isCatalog : isCatalog2;
    if (formEl.hasClass('js-initialized')) {
        return;
    }
    formEl.addClass('js-initialized');

    const catalog = new Catalog();
    catalog.init();

    naja.addEventListener('complete', () => {
        catalog.load();
    });
}

function initDocuments() {
    let documentsGrid = $('#snippet-catalogEditTabs-tabContent-doklady-tabControl-grid-grid-grid');
    if (!documentsGrid.length || documentsGrid.hasClass('js-initialized')) {
        return;
    }

    documentsGrid.addClass('js-initialized');

    const documents = new Documents();
    documents.init();

    naja.addEventListener('complete', () => {
        documents.init();
    });
}

function initItems() {
    let itemsTab = $('#snippet-catalogEditTabs-tabContent-polozkynaskladech-tab');
    if (!itemsTab.length|| itemsTab.hasClass('js-initialized')) {
        return;
    }

    if (itemsTab.hasClass('js-initialized')) {
        return;
    }

    const items = new Items();
    items.init();

    naja.addEventListener('complete', () => {
        items.init();
    });
}


class StoreDevice {
    purchaseDateId = 'frm-deviceTabs-tabContent-zakladniinformace-tabControl-editForm-purchaseDate';
    serialSelectId = 'frm-deviceTabs-tabContent-zakladniinformace-tabControl-editForm-serialNumberSelect';
    serialId = 'frm-deviceTabs-tabContent-zakladniinformace-tabControl-editForm-serialNumber';

    init() {
        $('#'+this.purchaseDateId).change(this.setPurchaseDate.bind(this));

        const serial = $('#' + this.serialSelectId);
        serial.change(this.setPurchaseDate.bind(this));
        serial.prop('selectedIndex', 0); // Select the first option
        serial.trigger('change');        // Trigger the change event
             // Attach the event handler

        $('input[disabled]').each(function() {
            $(this).removeAttr('disabled').attr('readonly', true);
        });
    }
    setPurchaseDate(event)
    {
        const select = $(event.target);
        const selectedOption = select.find(':selected');
        const price = selectedOption.data('price');
        const date = selectedOption.data('date');
        select.closest('form').find('input[name=datePurchase]').val(date);
        select.closest('form').find('input[name=price]').val(price);
        if (select.attr('id') == this.serialSelectId) {
            $('#'+this.serialId).val(select.val());
        }
        // console.log({ price, date });
    }
}

class Catalog {
    constructor() {
        // Přesuneme measures přímo do třídy
        this.measures = {};
        this.validator = new InputsValidator();
    }

    init() {
        const catalog = this;
        if(Object.keys(this.measures).length === 0) {
            naja.makeRequest('GET', "?do=getMeasures", {}, { history: false })
                .then(response => {
                    catalog.measures = response.measures || {};
                });
        }

        this.load();
        return catalog;
    }

    load() {
        const catalog = this;

        this.validator.init();

        $('select[name=measureID]').off('change').on('change', catalog.updateDecimal.bind(catalog));
        $("input[name=actionActive]").off("change").on("change", function() {
            catalog.setAction(!$(this).prop("checked"));
            if ($(this).prop("checked")) {
                $("select[name=actionTerminationType]").change();
            }
        }).change();

        // při změně typu ukončení akce
        $("[name=actionTerminationType]").off('change').on("change", function() {
            if ($("[name=actionTerminationType]").val() == 1) {
                $("[name=actionStartDate]").prop("disabled", false).closest("div").show();
                $("[name=actionTerminationDate]").prop("disabled", false).closest("div").show();
                $("[name=actionTerminationAmount]").prop("disabled", true).closest("div").hide();
            } else {
                $("[name=actionStartDate]").prop("disabled", true).closest("div").hide();
                $("[name=actionTerminationDate]").prop("disabled", true).closest("div").hide();
                $("[name=actionTerminationAmount]").prop("disabled", false).closest("div").show();
            }
        }).change();

        $("[name=storeCardType]").off("change").on("change", function() {
            catalog.setCardType($(this).val());
        }).change();

        $("[name=actionActive]").change();
        $("[name=actionStartDate]").datepicker();
        $("[name=actionTerminationDate]").datepicker();

        $("[name=priceType]").off("change").on("change", catalog.setPriceType.bind(catalog)).change();
        catalog.bindPriceEvents();
        catalog.recalcPrices();
    }

    setCardType(type) {
        let readonly = true;
        if (type == 3) {
            readonly = false;
        }
        // Set readonly for inputs and textareas
        $(".service input, .service textarea").prop("readonly", readonly);
        // For selects, simulate readonly using Bootstrap styling and pointer-events
        $(".service select")
            .toggleClass("bg-light text-muted", readonly)
            .css("pointer-events", readonly ? "none" : "auto");
    }

    updateDecimal() {
        const decimal = $('input[name=measureDecimal]');
        const measureID = parseInt($('select[name=measureID]').val()) || 0;
        const measures = this.measures || {};
        decimal.val(measureID in measures ? measures[measureID] : 0);
    }

    setAction(disabled) {
        $("[name=actionPrice]").prop("readonly", disabled);
        $("[name=actionTerminationType]").prop("readonly", disabled);
        $("[name=actionTerminationAmount]").prop("readonly", disabled);
        $("[name=actionStartDate]").prop("readonly", disabled);
        $("[name=actionTerminationDate]").prop("readonly", disabled);

        if (disabled) {
            $("[name=actionTerminationAmount]").closest("div").hide();
            $("[name=actionStartDate]").closest("div").hide();
            $("[name=actionTerminationDate]").closest("div").hide();
        }
    }

    setPriceType() {
        if ($("[name=priceType]").val() == 1) {
            $("[name=saleMargin]")
                .prop("readonly", true)
                .addClass("readonly");
            $("[name=salePriceWithoutFees]")
                .prop("readonly", false)
                .removeClass("readonly");
        } else {
            $("[name=saleMargin]")
                .prop("readonly", false)
                .removeClass("readonly");
            $("[name=salePriceWithoutFees]")
                .prop("readonly", true)
                .addClass("readonly");
        }
    }

    bindPriceEvents() {
        var self = this;
        $("[name=feeRecycle], [name=purchasePrice], [name=feeCopyright], [name=salePriceWithoutFees], [name=salePriceTotal], [name=saleMargin]")
            .off('keyup').on("keyup", function(e) {
                var el = $(e.target);
                if (parseFloat(el.val()) !== parseFloat(el.prop("defaultValue"))) {
                    el.addClass("changed");
                } else {
                    el.removeClass("changed");
                }

                self.recalcPrices(e);
            });

        $("[name=taxVatSaleID]")
            .off('change').on("change", function(e) {
                self.recalcPrices(e);
            });
    }

    recalcPrices(e) {
        if (typeof e !== 'undefined' && (e.key === '.' || e.key === ',')) {
            return;
        }

        const purchasePrice = parseFloat(document.querySelector('[name=purchasePrice]')?.value) || 0;
        const feeRecycle = parseFloat(document.querySelector('[name=feeRecycle]')?.value) || 0;
        const feeCopyright = parseFloat(document.querySelector('[name=feeCopyright]')?.value) || 0;
        const saleMarginInput = document.querySelector('[name=saleMargin]');
        const salePriceWithoutFeesInput = document.querySelector('[name=salePriceWithoutFees]');
        const salePriceTotalInput = document.querySelector('[name=salePriceTotal]');
        const salePriceInput = document.querySelector('[name=salePrice]');

        let saleMargin = parseFloat(saleMarginInput?.value) || 0;
        let salePriceWithoutFees = parseFloat(salePriceWithoutFeesInput?.value) || 0;
        let salePriceTotal = parseFloat(salePriceTotalInput?.value) || 0;
        let salePrice = 0;

        // U Pevné ceny (priceType == 1) je salePriceWithoutFees zadávaná ručně a je neměnná,
        // marže je jen informativní - proto se z marže nesmí dopočítávat zpět a "ujíždět" o haléře
        const isFixedPrice = $("[name=priceType]").val() == 1;

        // Výpočet základní prodejní ceny bez poplatků z nákupní ceny a marže
        const computedSalePriceWithoutFees = parseFloat((purchasePrice * (1 + saleMargin / 100)).toFixed(4));
        if (!isFixedPrice) {
            if (typeof e === 'undefined') {
                // Na initial loadu přepočítat jen pokud je nákupní cena > 0,
                // jinak zachovat načtenou hodnotu (zabrání přepsání nulou)
                if (purchasePrice > 0) {
                    salePriceWithoutFees = computedSalePriceWithoutFees;
                }
            } else if (e.target.name !== "salePriceWithoutFees") {
                salePriceWithoutFees = computedSalePriceWithoutFees;
            }
        }

        let rate = 0;
        const taxVatSale = document.querySelector('[name="taxVatSaleID"]');
        if (taxVatSale) {
            const selectedOption = taxVatSale.options[taxVatSale.selectedIndex];
            if (selectedOption) {
                rate = parseFloat(selectedOption.dataset.rate) || 0;
            }
        }

        const taxRate = (rate / 100) + 1;

        if (typeof e !== 'undefined' && e.target.name === "salePriceTotal") {
            salePrice = parseFloat((salePriceTotal / taxRate).toFixed(4));
            salePriceWithoutFees = parseFloat((salePrice - feeRecycle - feeCopyright).toFixed(4));
        } else {
            salePrice = parseFloat((salePriceWithoutFees + feeRecycle + feeCopyright).toFixed(4));
            salePriceTotal = parseFloat((salePrice * taxRate).toFixed(4));
        }

        if (isFixedPrice && (typeof e === 'undefined' || (e.target.name !== "saleMargin" && purchasePrice > 0))) {
            saleMargin = parseFloat((((salePriceWithoutFees - purchasePrice) / purchasePrice) * 100).toFixed(2));
        }

        // Aktualizace hodnot v inputech pomocí IMask
        if (salePriceTotalInput) {
            this.validator.updateMaskedValue(salePriceTotalInput, salePriceTotal);
        }

        if (salePriceInput) {
            this.validator.updateMaskedValue(salePriceInput, salePrice);
        }

        if (salePriceWithoutFeesInput) {
            this.validator.updateMaskedValue(salePriceWithoutFeesInput, salePriceWithoutFees);
        }

        if (saleMarginInput) {
            this.validator.updateMaskedValue(saleMarginInput, saleMargin);
        }
    }
}

class Documents {
    init() {
        const targetNode = document.querySelector('#snippet-catalogEditTabs-tabContent-doklady-tabControl-grid-grid-tbody');
        if (!targetNode) return;
        const totalCountElement = document.getElementById('totalCount');
        const config = { childList: true, subtree: true };
        const observer = new MutationObserver(() => {
            let totalSum = 0;
            const rows = targetNode.querySelectorAll('tr');
            rows.forEach(row => {
                const cells = row.querySelectorAll('td');
                if (cells.length >= 6) {
                    let value = parseFloat(cells[5].textContent.trim());
                    if (!isNaN(value)) {
                        totalSum += value;
                    }
                }
            });
            if (totalCountElement) {
                totalCountElement.textContent = totalSum;
            }
        });
        observer.observe(targetNode, config);
    }
}

class Items {
    init() {
        $(document)
            .off('click', '.expand-group')
            .on('click', '.expand-group', function() {
                const $icon = $(this).find('i.bi');
                $(this).nextUntil('.expand-group', '.expand-group-item').toggleClass('d-none');
                if ($icon.hasClass('bi-plus-square')) {
                    $icon.removeClass('bi-plus-square').addClass('bi-dash-square');
                } else {
                    $icon.removeClass('bi-dash-square').addClass('bi-plus-square');
                }
            });
    }
}


